/**
 * Absolute paths for the Annual Process section's tab routes — same rationale
 * as `compliance-reviews/routes.ts` / `regulatory-references/routes.ts`: the
 * child's `to`, the router record and each tab's own list table all import
 * from here rather than retyping the string.
 */
export const ANNUAL_CERTIFICATION_PATH = '/annual-certification'
export const ANNUAL_CERTIFICATION_NOT_REQUIRED_PATH = '/annual-certification/not-required'
export const ANNUAL_CERTIFICATION_COMPLETED_PATH = '/annual-certification/completed'
